import { VIDEOINNER_FETCH_DATA_SUCCESS, VIDEOINNER_HAVE_ERROR, VIDEOINNER_ARE_LOADING } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function VideoInnerReducer (state = initialState, action) {
    switch (action.type) {
        case VIDEOINNER_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case VIDEOINNER_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case VIDEOINNER_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.VideoInner,
                loading:false,
            }

        default:
            return state;
    }
}
